/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nestedDashboardOptionsEditor.vue?vue&type=template&id=13ccfcef"
import script from "./nestedDashboardOptionsEditor.vue?vue&type=script&lang=js"
export * from "./nestedDashboardOptionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports